module.exports = __webpack_public_path__ + "static/media/38.c04ef595.mp3";